import SalesOrderList from '../components/SalesOrderList';

function CustomerPortalPage() {

  return (
      <SalesOrderList
        isAdmin={false}
      />
  );
}

export default CustomerPortalPage;

